export default __webpack_public_path__ + "static/blog-04-900x678-2f74b38d5ade53b669d95b1284520bc6.jpg";